export enum LearningResourceType {
    LearningCourse = 0,
    LearningPath = 1,
}